import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Timetable } from './Timetable';
import { TimetableGroup } from './TimetableGroup';

export interface TimetableSessionRow {
  id: number;
  timetable_id: number;
  title: string;
  group_id: number;
  start_time: string;
  end_time: string;
  color_code?: string | null;
  created_at: string;
  updated_at: string;
}

export const TimetableSession: Entity<TimetableSessionRow> = {
  id: 'TimetableSession',
  title: 'Timetable Session',
  service: 'main',
  rowLabel: (row: TimetableSessionRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.timetable_session',
  },
  security: [{ role: 'staff', action: 'all', access: 'all' }],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    timetable_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Timetable',
      refEntity: Timetable,
      mandatory: true,
      listColumn: true,
    },
    title: {
      seq: 15,
      type: FieldType.Text,
      label: 'Title',
      mandatory: true,
      listColumn: true,
    },
    group_id: {
      seq: 20,
      type: FieldType.Reference,
      label: 'Group',
      refEntity: TimetableGroup,
      mandatory: true,
      listColumn: true,
    },
    start_time: {
      seq: 25,
      type: FieldType.Datetime,
      label: 'Start Time',
      mandatory: true,
      listColumn: true,
    },
    end_time: {
      seq: 30,
      type: FieldType.Datetime,
      label: 'End Time',
      mandatory: true,
      listColumn: true,
    },
    color_code: {
      seq: 32,
      type: FieldType.Colour,
      label: 'Override Colour',
      mandatory: false,
      listColumn: true,
    },
    created_at: {
      seq: 35,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
    },
    updated_at: {
      seq: 40,
      type: FieldType.Datetime,
      label: 'Updated At',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
